import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router-dom'
import InternalLink from 'components/views/internalLink/InternalLink';

import './flashMessages.scss';

import uiStore from 'storeState/ui';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';

export class FlashMessages extends Component {

    static contextTypes = {
        intl: PropTypes.object
    }


    render() {
        const {formatMessage} = this.context.intl;
        const loginData = this.props.loginData;

        return (
            <div className={`flash-messages`}>
                <For each="item" of={this.props.flashMessages}>
                    <div className={`flash-message flash-message-${item.type}`}>
                        {item.message}
                    </div>
                </For>
            </div>
        );
    }
}


export default connect((state, props) => {
  return {
    flashMessages: uiStore.selectors.getFlashMessages(state)
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, uiStore.actions), dispatch)
  }
})(FlashMessages)



// WEBPACK FOOTER //
// ./src/components/views/flashMessages/FlashMessages.js